import { effect, signal } from "@preact/signals-react";
import { getShareableSetting, setShareableSetting, } from "../shared/services/transforms";
const KEY = "selectedForecastView";
const DEFAULT_VIEW = "day";
const getInitialView = () => {
    const savedView = getShareableSetting(KEY);
    if (savedView === "day" || savedView === "week" || savedView === "year") {
        return savedView;
    }
    return DEFAULT_VIEW;
};
export const selectedForecastView$ = signal(getInitialView());
let isInitialLoad = true;
effect(() => {
    const value = selectedForecastView$.value;
    if (isInitialLoad) {
        isInitialLoad = false;
        return;
    }
    setShareableSetting(KEY, value);
});
//# sourceMappingURL=forecastView.js.map